/**
 * Le moment d'une commande, tel qu'on l'affiche sur une carte.
 *
 *   aujourd'hui       → « 14:31 »
 *   hier              → « Hier 14:31 »
 *   avant             → « 28/09 14:31 »
 *   une autre année   → « 28/09/25 14:31 »
 *
 * Sept écrans avaient chacun leur copie de cette règle, et celle de l'app
 * marchand perdait l'heure dès que la commande n'était plus du jour. L'heure
 * n'est jamais retirée : c'est elle qu'on cherche sur une carte du jour, et
 * elle aide encore à retrouver une commande plus ancienne.
 */
export function formatOrderTime(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';

  const now = new Date();
  const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === now.toDateString()) return time;

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Hier ${time}`;

  const dateOptions = { day: '2-digit', month: '2-digit' };
  if (d.getFullYear() !== now.getFullYear()) dateOptions.year = '2-digit';
  return `${d.toLocaleDateString('fr-FR', dateOptions)} ${time}`;
}
